/** Strip the internal [basiq:...] dedup prefix from transaction descriptions */
export function stripBasiqPrefix(description: string): string {
  return description.replace(/^\[basiq:[^\]]+\]\s*/, '');
}

export function formatAUD(amount: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  }).format(amount);
}

export function generateId(): string {
  return crypto.randomUUID();
}

/** Get the financial year label for a given date (e.g. "2025-26") */
export function getFinancialYear(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth(); // 0-indexed
  if (month >= 6) {
    // Jul onwards = start of new FY
    return `${year}-${(year + 1).toString().slice(-2)}`;
  }
  return `${year - 1}-${year.toString().slice(-2)}`;
}

/** Get start date of the financial year containing the given date */
export function getFinancialYearStart(date: Date): Date {
  const year = date.getFullYear();
  const month = date.getMonth();
  if (month >= 6) {
    return new Date(year, 6, 1); // Jul 1
  }
  return new Date(year - 1, 6, 1);
}

export function getFinancialYearEnd(date: Date): Date {
  const start = getFinancialYearStart(date);
  return new Date(start.getFullYear() + 1, 5, 30); // Jun 30
}
